import { NextPageContext } from "next";
import diContainer from "true-di";

import storage from "./storage";
import storageService from "./storageService";
import { priceItem } from "./storageService/priceItem";
import { billingInfo } from "./storageService/billingInfo";
import { token } from "./storageService/token";
import { refreshToken } from "./storageService/refreshToken";

export const PersistentStorage = (globalContext: NextPageContext | null) =>
	diContainer({
		globalContext: () => globalContext,
		storage,
		priceItem,
		billingInfo,
		token,
		refreshToken,
		storageService,
	}).storageService;
